
export default class {
	constructor() {
		this.scrollIn = '.js-scrollIn';
		this.isActive = 'is-active';
		this.init();
	}

	init() {
		const scrollObjects = document.querySelectorAll(this.scrollIn);
		const cb = (entries, observer) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add(this.isActive);
					observer.unobserve(entry.target);
				}
			});
		}
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0
		}
		const io = new IntersectionObserver(cb, options);
		scrollObjects.forEach(object => {
			io.observe(object);
		});
	}
}